export default __webpack_public_path__ + "static/media/xcovers-1-rMAX.1285642e.jpg";